import { DocumentInputType } from '../model/documentInput.model'

export function isPhoneNumberType(documentType: DocumentInputType) {
  return documentType === DocumentInputType.CLI || documentType === DocumentInputType.MSISDN
}
